export const isActualEvent = (str: string) => {
  const now = new Date().getTime();
  const eventTime = new Date(str).getTime();

  return eventTime > now;
};
